import { getBlogArticleParentPath } from '@navinc/common'
import { toCanonicalPathname } from './to-canonical-pathname.js'

const pagesCollection = 'pages'
const articlesCollection = 'articles'
const articlesRoute = 'blog'

export const pagePathname = (
  relationTo: string | null | undefined,
  doc:
    | { slug?: string | null; parent?: { slug?: string | null } | null; resourceCategory?: string | null }
    | null
    | undefined,
) => {
  const slug = doc?.slug
  let parentSlug = doc?.parent?.slug
  if (relationTo === 'articles' && doc?.resourceCategory) {
    parentSlug = getBlogArticleParentPath(doc.resourceCategory)
  }
  // articles are served from a different route for now
  const route = relationTo === articlesCollection ? articlesRoute : relationTo
  const pathname = route === pagesCollection ? `/${parentSlug ? `${parentSlug}/` : ''}${slug}` : `/${route}/${slug}`

  // Special case for home page
  if (relationTo === pagesCollection && slug === 'home') {
    return '/'
  }

  return toCanonicalPathname(pathname)
}
